// frontend/src/components/parts/PartComments.js
// Part-specific wrapper around the shared comment thread.
import React from 'react';
import { Box, Button } from '@mui/material';

import CommentThread from '../common/CommentThread';
import { getPartComments, addPartComment } from '../../services/endpoints';

const PartComments = ({ partId, onClose }) => (
    <Box>
        <CommentThread
            onLoad={() => getPartComments(partId).then(r => r.data)}
            onAdd={(text) => addPartComment(partId, text)}
        />
        {onClose && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button onClick={onClose}>Close</Button>
            </Box>
        )}
    </Box>
);

export default PartComments;
